import { render } from "./BlogPostListPage.vue?vue&type=template&id=539b25e4&scoped=true&ts=true"
import script from "./BlogPostListPage.vue?vue&type=script&lang=ts"
export * from "./BlogPostListPage.vue?vue&type=script&lang=ts"

import "./BlogPostListPage.vue?vue&type=style&index=0&id=539b25e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539b25e4"]])

export default __exports__